// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"114":"01c80a97","266":"5a128e97","379":"da18e38c"}[chunkId] + ".chunk.css";
};